import { Competition } from "@brg/api";
import { COMPETITION_TYPE } from "_competition/const";

export enum CompetitionInputNames {
    FULLNAME = 'fullName',
    EMAIL = 'email',
    PHONE = 'phone',
    BIRTH_DATE = 'birthDate',
    EDUCATION_PLACE = 'educationPlace',
    FACULTY = 'faculty',
    END_YEAR = 'endYear',
    CITY = 'city',
    OCCUPATION = 'occupation',
    TELEGRAM = 'telegram',
    COUNTRY = 'country',
    PORTFOLIO_LINK = 'portfolioLink',
    CITIZENSHIP = 'citizenship',
    VIDEO_LINK = 'videoLink',
    COME_AGREE = 'come_agree',
    NOMINATIONS_LIST = 'nominationsList',
    TYPE_OF_AWARD = 'typeOfAward',
    NOMINATION_NAME = 'nominationName',
    PROJECT_NAME_RU = 'projectName_ru',
    PROJECT_NAME_EN = 'projectName_en',
    PROJECT_YEAR = 'projectYear',
    TIMING = 'timing',
    CREATE_COUNTRY = 'createCountry',
    ABOUT_RU = 'about_ru',
    ABOUT_EN = 'about_en',
    HAS_SUBTITLES = 'hasSubtitles',
    CLOUD_LINK = 'cloudLink',
    PDF_LINK = 'pdfLink',
    PUBLISHING = 'publishing',
    AUTHOR = 'author',
    EDITOR = 'editor',
    PROJECT_ID = 'projectId',
    NOMINATION_ID = 'nominationId',
    BOOK_NAME = 'bookName',
    WEB_SITE = 'webSite',
    CONTACT_PERSON = 'contactPerson',
    BOOK_YEAR = 'bookYear',
    REG_NUMBER = 'regNumber',
    //пререгистрация
    NOMINATION = 'nomination',
    SUBNOMINATION = 'subnomination',
    NAMES = 'names',
    VOCATION = 'vocation',
    SITE = 'site',
    SOCIAL = 'social',
    PORTRAIT_LINK = 'portraitLink',
    OBJECT_PHOTO_LINK = 'objectPhotoLink',
    MEDIA = 'media',
    PHOTOGRAPHER = 'photographer',
    SHOOTING_STYLIST = 'shootingStylist',
    YEAR = 'year',
    AREA = 'area',
    BRANDS = 'brands',
    DESCRIPTION = 'description',
    COURSE_OF_STUDY = 'courseOfStudy',
    PROFILE_OF_STUDY = 'profileOfStudy'
  }
  
export enum CompetitionConsentNames {
    AGREE_ONE = 'agreeOne',
    AGREE_TWO = 'agreeTwo',
    AGREE_THREE = 'agreeThree',
    AGREE_FOUR = 'agreeFour',
    AGREE_FIVE = 'agreeFive',
    AGREE_SIX = 'agreeSix',
    CONSENT_TO_USE = 'consentToUse',
    CONSENT_TO_DEMONSTRATE = 'consentToDemonstrate',
    CONSENT_FILE = 'consentFile',
}

export enum DOCUMENT_VARIANT {
    none = 'none',
    short = 'short',
    full = 'full'
}

export const getDocumentVariant = (c: Competition) => {
    const rawType = c?.competitionType;
    const hasCompetitionType = Number.isInteger(rawType);
    const isWithQuestionnaire = hasCompetitionType
        ? rawType === COMPETITION_TYPE.WithQuestionnaire || !!c?.isPaidCompetition
        : !!c?.nominations?.[0]?.needToFillForm;
    if (isWithQuestionnaire && !!c?.nominations?.[0]?.documentsIds?.length) {
        return DOCUMENT_VARIANT.full;
    }
    if (isWithQuestionnaire && c?.nominations?.[0]?.documentsIds?.length === 0) {
        return DOCUMENT_VARIANT.short;
    }
    return DOCUMENT_VARIANT.none;
};import { Competition } from "@brg/api";
import { COMPETITION_TYPE } from "_competition/const";

export enum CompetitionInputNames {
    FULLNAME = 'fullName',
    EMAIL = 'email',
    PHONE = 'phone',
    BIRTH_DATE = 'birthDate',
    EDUCATION_PLACE = 'educationPlace',
    FACULTY = 'faculty',
    END_YEAR = 'endYear',
    CITY = 'city',
    OCCUPATION = 'occupation',
    TELEGRAM = 'telegram',
    COUNTRY = 'country',
    PORTFOLIO_LINK = 'portfolioLink',
    CITIZENSHIP = 'citizenship',
    VIDEO_LINK = 'videoLink',
    COME_AGREE = 'come_agree',
    NOMINATIONS_LIST = 'nominationsList',
    TYPE_OF_AWARD = 'typeOfAward',
    NOMINATION_NAME = 'nominationName',
    PROJECT_NAME_RU = 'projectName_ru',
    PROJECT_NAME_EN = 'projectName_en',
    PROJECT_YEAR = 'projectYear',
    TIMING = 'timing',
    CREATE_COUNTRY = 'createCountry',
    ABOUT_RU = 'about_ru',
    ABOUT_EN = 'about_en',
    HAS_SUBTITLES = 'hasSubtitles',
    CLOUD_LINK = 'cloudLink',
    PDF_LINK = 'pdfLink',
    PUBLISHING = 'publishing',
    AUTHOR = 'author',
    EDITOR = 'editor',
    PROJECT_ID = 'projectId',
    NOMINATION_ID = 'nominationId',
    BOOK_NAME = 'bookName',
    WEB_SITE = 'webSite',
    CONTACT_PERSON = 'contactPerson',
    BOOK_YEAR = 'bookYear',
    REG_NUMBER = 'regNumber',
    //пререгистрация
    NOMINATION = 'nomination',
    SUBNOMINATION = 'subnomination',
    NAMES = 'names',
    VOCATION = 'vocation',
    SITE = 'site',
    SOCIAL = 'social',
    PORTRAIT_LINK = 'portraitLink',
    OBJECT_PHOTO_LINK = 'objectPhotoLink',
    MEDIA = 'media',
    PHOTOGRAPHER = 'photographer',
    SHOOTING_STYLIST = 'shootingStylist',
    YEAR = 'year',
    AREA = 'area',
    BRANDS = 'brands',
    DESCRIPTION = 'description',
    COURSE_OF_STUDY = 'courseOfStudy',
    PROFILE_OF_STUDY = 'profileOfStudy'
  }
  
export enum CompetitionConsentNames {
    AGREE_ONE = 'agreeOne',
    AGREE_TWO = 'agreeTwo',
    AGREE_THREE = 'agreeThree',
    AGREE_FOUR = 'agreeFour',
    AGREE_FIVE = 'agreeFive',
    AGREE_SIX = 'agreeSix',
    CONSENT_TO_USE = 'consentToUse',
    CONSENT_TO_DEMONSTRATE = 'consentToDemonstrate',
    CONSENT_FILE = 'consentFile',
}

export enum DOCUMENT_VARIANT {
    none = 'none',
    short = 'short',
    full = 'full'
}

export const getDocumentVariant = (c: Competition) => {
    const rawType = c?.competitionType;
    const hasCompetitionType = Number.isInteger(rawType);
    const isWithQuestionnaire = hasCompetitionType
        ? rawType === COMPETITION_TYPE.WithQuestionnaire || !!c?.isPaidCompetition
        : !!c?.nominations?.[0]?.needToFillForm;
    if (isWithQuestionnaire && !!c?.nominations?.[0]?.documentsIds?.length) {
        return DOCUMENT_VARIANT.full;
    }
    if (isWithQuestionnaire && c?.nominations?.[0]?.documentsIds?.length === 0) {
        return DOCUMENT_VARIANT.short;
    }
    return DOCUMENT_VARIANT.none;
};